<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.dc_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="dc_content">
            <label class="weui-form-preview__label">{{customLabel.dc_content || "变更内容"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.dc_content
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="dc_decode">
              <label class="weui-form-preview__label">{{customLabel.dc_decode || "需求单号"}}</label>
              <span class="weui-form-preview__value">{{
                 form.main.dc_decode
              }}</span>
            </div>
            <change-field
              slot="项目名称"
              label="项目名称"
              :old-value="form.main.dc_name_old"
              :new-value="form.main.dc_name_new"
            />
            <change-field
              slot="客户名称"
              label="客户名称"
              :old-value="form.main.dc_custname_old"
              :new-value="form.main.dc_custname_new"
            />
            <change-field
              slot="产品类型"
              label="产品类型"
              :old-value="form.main.dc_product_type_old"
              :new-value="form.main.dc_product_type_new"
            />
            <change-field
              slot="目标成本"
              label="目标成本"
              :old-value="form.main.dc_cost_old"
              :new-value="form.main.dc_cost_new"
            />
            <change-field
              slot="销售计划"
              label="销售计划"
              :old-value="form.main.dc_annual_sales_plan_old"
              :new-value="form.main.dc_annual_sales_plan_new"
            />
            <change-field
              slot="销售目标区域"
              label="销售目标区域"
              :old-value="form.main.dc_sales_area_old"
              :new-value="form.main.dc_sales_area_new"
            />
            <change-field
              slot="销售目标群体"
              label="销售目标群体"
              :old-value="form.main.dc_sales_group_old"
              :new-value="form.main.dc_sales_group_new"
            />
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"          
        >
          <div class="form-detail-preview_num">{{ item.ddc_ddno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <change-field
              slot="名称"
              label="名称"
              :old-value="item.ddc_name_old"
              :new-value="item.ddc_name_new"
            />
            <change-field
              slot="规格"
              label="规格"
              :old-value="item.ddc_spec_old"
              :new-value="item.ddc_spec_new"
            />
            <change-field
              slot="品牌"
              label="品牌"
              :old-value="item.ddc_brand_old"
              :new-value="item.ddc_brand_new"
            />
            <change-field
              slot="颜色"
              label="颜色"
              :old-value="item.ddc_colour_old"
              :new-value="item.ddc_colour_new"
            />
            <change-field
              slot="材质"
              label="材质"
              :old-value="item.ddc_texture_old"
              :new-value="item.ddc_texture_new"
            />
            <change-field
              slot="丝印"
              label="丝印"
              :old-value="item.ddc_silkscreen_old"
              :new-value="item.ddc_silkscreen_new"
            />
            <change-field
              slot="标准"
              label="标准"
              :old-value="item.ddc_standard_old"
              :new-value="item.ddc_standard_new"
            />
            <change-field
              slot="尺寸"
              label="尺寸"
              :old-value="item.ddc_size_old"
              :new-value="item.ddc_size_new"
            />
            <change-field
              slot="备注"
              label="备注"
              :old-value="item.ddc_remark_old"
              :new-value="item.ddc_remark_new"
            />
          </custom-layout>
        </div>
      </div>
    </div>
    <!-- <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/stock/in_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div> -->
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ChangeField from "@/components/field/ChangeField";
import form from "@/mixins/form.js";

export default {
  components: {
    CustomLayout,
    ChangeField
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/plm/demandChange",
      // codeField: "pi_inoutno",
      // statusField: "pi_statuscode",
      // caller: 'ProductInit',
      // xtype:'stock-productinit-formpanel'
    };
  }
}
</script>